"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("../index.less");
var _index2 = _interopRequireDefault(require("@/components/reTitle/index"));
var _user = require("@/api/user/user");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      backPath: "/teacherIndex",
      tabsActNum: 0,
      titleInfo: {},
      newTypeList: [],
      reNewsInfo: [],
      totalNum: 0,
      page: {
        pageSize: 12,
        pageNumber: 1
      },
      regList: [{
        name: "教师注册"
      }, {
        name: "学生注册"
      }],
      form: {
        businessId: "",
        achievement: "",
        classes: "",
        fax: "",
        id: "",
        idCard: "",
        mail: "",
        major: "",
        mobile: "",
        name: "",
        nation: "",
        phone: "",
        registerType: 2,
        schoolId: "",
        sex: "",
        title: "",
        type: "",
        userId: "",
        zipCode: "",
        schoolName: "",
        qq: "",
        job: ""
      },
      regRules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "请输入职称",
          trigger: "blur"
        }],
        idCard: [{
          required: true,
          message: "请输入身份证号",
          trigger: "blur"
        }, {
          validator: _validate.validateIdNo,
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入手机号码",
          trigger: "blur"
        }, {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        mail: [{
          required: true,
          message: "请输入电子邮箱",
          trigger: "blur"
        }, {
          validator: _validate.validateEMail,
          trigger: "blur"
        }],
        job: [{
          required: true,
          message: "请输入职务",
          trigger: "blur"
        }],
        sex: [{
          required: true,
          message: "请选择性别",
          trigger: "change"
        }],
        major: [{
          required: true,
          message: "请输入所学专业",
          trigger: "blur"
        }],
        classes: [{
          required: true,
          message: "请输入所在年级",
          trigger: "blur"
        }],
        schoolId: [{
          required: true,
          message: "请选择所属学校",
          trigger: "change"
        }],
        type: [{
          required: true,
          message: "请选择注册类型",
          trigger: "change"
        }]
      },
      bsId: "",
      schoolList: []
    };
  },
  methods: {
    // 注册提交
    onSubmit: function onSubmit(val) {
      var _this = this;
      this.form.businessId = this.bsId;
      this.$refs[val].validate(function (valid) {
        if (valid) {
          var param = _this.form;
          (0, _user.registerRole)(param).then(function (res) {
            _this.$message.success("注册成功。");
          });
        }
      });
    },
    //根据省份获得bsid
    getID: function getID() {
      var _this2 = this;
      (0, _user.getBSID)({
        param: this.prCode
      }).then(function (res) {
        _this2.bsId = res.data;
        _this2.getSchool();
      });
    },
    // 获取学校id
    getSchool: function getSchool() {
      var _this3 = this;
      (0, _user.getSchoolLIST)({
        param: this.prCode
      }).then(function (res) {
        _this3.schoolList = res.data;
      });
    },
    onchange: function onchange(e) {
      this.form.schoolName = e.name;
    }
  },
  created: function created() {
    this.getID();
    var v = this.$route;
    this.titleInfo.sec = v.meta.title;
    this.titleInfo.path = v.fullPath;
  },
  components: {
    RealTitle: _index2.default
  }
};